import { render, staticRenderFns } from "./ContentUpdate.vue?vue&type=template&id=df626a6e"
import script from "../../services/upload/contentedit.js?vue&type=script&lang=js&external"
export * from "../../services/upload/contentedit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports